import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import useMainPriceOfCard from '../../hooks/useMainPriceOfCard'

import { Price } from '~/basket/model/common/price.model'

const useMainPriceOfCardStyles = makeStyles(() => ({
  price: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    '& > span': {
      marginRight: '4px',
    },
  },
  mainSubPriceContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

export interface MainPriceOfCard {
  price?: Price
  isOnlyPrice: boolean
}

export default function MainPriceOfCard({
  price,
  isOnlyPrice,
}: MainPriceOfCard): React.ReactElement {
  const classes = useMainPriceOfCardStyles()

  const { integer, decimal, amountAndDuration } = useMainPriceOfCard({ price, isOnlyPrice })

  return (
    <div className={classes.price}>
      <Typography component="span" variant="h2" className="big" data-hook="integer">
        {integer}
      </Typography>
      <div className={classes.mainSubPriceContainer}>
        <Typography component="span" variant="caption" color="textSecondary" data-hook="decimal">
          &apos;{decimal} €/mes
        </Typography>
        <Typography component="span" variant="caption" color="textSecondary" className="regular">
          {amountAndDuration}
        </Typography>
      </div>
    </div>
  )
}
